import { Button } from '@app/components/various/Button';
import { Reset, Visibility } from '@app/components/various/Icons';
import { Skeleton } from '@app/components/various/Skeleton';
import { useLookbookDetails } from '@app/services/hooks/lookbook/useLookbookDetails';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Props {
  hasChanges?: boolean;
  isDisabled?: boolean;
  isSubmitting?: boolean;
  onReset?: () => void;
  formName?: string;
  headingLink: string;
  hasActionButtons?: boolean;
  lookbookId?: string;
  onSubmit?: () => void;
}

export const LookbookSectionFormHeading = ({
  hasChanges = false,
  onReset,
  isDisabled,
  isSubmitting,
  formName,
  headingLink,
  hasActionButtons = true,
  lookbookId,
  onSubmit,
}: Props) => {
  const { t } = useTranslation(['common', 'lookbook']);
  const { data: lookbookSettings, isLoading: isLoadingLookbookSettings } = useLookbookDetails({ lookbookId });

  const lookbookName =
    isDefined(lookbookSettings?.name) && !isEmpty(lookbookSettings.name) ? lookbookSettings.name : t('lookbook:lookbook');

  return (
    <div className="sticky top-[--headerHeight] z-topBar flex h-24 w-full items-center justify-between gap-4 bg-neutral-96 py-3 transition-all group-[.scrollingDown]/body:top-0 lg:pb-7 lg:pt-7">
      {isLoadingLookbookSettings ?
        <Skeleton type="rectangle" className="h-10 w-80" />
      : <Link to={headingLink} className="flex items-center gap-2 underline">
          <h2 className="heading-2 sm:heading-1">{lookbookName}</h2>
          <Visibility className="size-5 text-neutral-40" />
        </Link>
      }
      {hasActionButtons && (
        <div className="flex gap-2">
          <Button
            color="secondary"
            variant="bordered"
            icon={Reset}
            disabled={isLoadingLookbookSettings || isDisabled || !hasChanges}
            onClick={onReset}
          >
            {t('common:reset')}
          </Button>
          <Button type="submit" isLoading={isSubmitting} disabled={isDisabled} form={formName} onClick={onSubmit}>
            {t('common:save')}
          </Button>
        </div>
      )}
    </div>
  );
};
